import React, {useState} from "react";
import avatar from "assets/img/profile/Subtractprofile white.png";
import banner from "assets/img/profile/banner.png";
import Card from "components/card";
import useAsyncEffect from "use-async-effect";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const Banner = () => {
    let [userProfile, setUserProfile] = useState([])
    let [homesCount, setHomesCount] = useState("0")
    let [roomsCount, setRoomsCount] = useState("0")
    let [devicesCount, setDevicesCount] = useState("0")


    let [acl, setAcl] = useState("User")

    function getAclNameFromAclValue(acl) {
        switch (acl) {
            case "0":
                return "User"
            case "1":
                return "Administrator"
            case "2":
                return "Developer"
            case "3":
                return "Marketing User"
            case "4":
                return "App Developer"
            case "5":
                return "Analytics User"

            default:
                return "User"

        }
    }

    var sv = "";

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ORIGIN_URL = process.env.REACT_APP_CROMPTON_SENZE_ORIGIN_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    let [isLoading, setIsLoading] = useState(true)


    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [dp, setDp] = useState("")
    let [userName, setUserName] = useState("")

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getDp() {
        //var url = CROMPTON_ORIGIN_URL + "images/dp/" + decryptedValueuname
        var url = CROMPTON_ORIGIN_URL + "images/V2/dp"

        return axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }, responseType: 'blob',

        }).then((res) => {
            //console.log(res)
            //var im = JSON.parse(res.data);
            //document.getElementById("myimage").src = URL.createObjectURL(res.data);
            setDp(URL.createObjectURL(res.data))


        }).catch((error) => {
            //console.log(error)
            setDp(avatar)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })
    }

    function getUserProfile() {
        //var url = CROMPTON_URL + "user/v2/get/" + decryptedValueuname
        var url = CROMPTON_URL + "user/V3/get"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            //console.log(res.data)

            if ((res.data.name === "") || (res.data.name === null)) {
                setUserName("User")
            } else {
                setUserName(res.data.name)
            }
            sessionStorage.setItem("UserProfile", JSON.stringify(res.data))

        }).catch((error) => {
            //console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })
    }

    function getUserDeviceHomeRoomStats() {

        var url = CROMPTON_ANALYTICS_URL + "v1/user/normalUserStats/" + decryptedValueuname

        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            setHomesCount(res.data.totalHomes)
            setRoomsCount(res.data.totalRooms)
            setDevicesCount(res.data.totalDevices)

            setAcl(getAclNameFromAclValue(accesscontrollevel.toString()))
            acl = getAclNameFromAclValue(accesscontrollevel.toString())

            setIsLoading(false)

        }).catch((error) => {
            //console.log(error)
            setIsLoading(false)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useAsyncEffect(async () => {
            getDp()
            getUserProfile()
            getUserDeviceHomeRoomStats()
        }, [""]
    );

    return (
        <Card extra={"items-center w-full h-full p-[16px] bg-cover"}>
            {/* Background and profile */}
            {!isLoading &&
                <div>
                    <div
                        className="relative mt-1 flex h-32 w-full justify-center rounded-xl bg-cover"
                        style={{backgroundImage: `url(${banner})`}}>
                        <div
                            className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center rounded-full border-[4px] border-white bg-[#E0E5F2] dark:!border-navy-700">
                            <img className="h-full w-full rounded-full" src={dp} alt=""/>
                        </div>
                    </div>
                    {/* Name and position */}
                    <div className="mt-16 flex flex-col items-center">
                        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                            {userName}
                        </h4>
                        <p className="text-base font-normal text-gray-600">{acl}</p>
                    </div>

                    {/* Post followers */}
                    <div className="mt-6 mb-3 flex gap-4 md:!gap-14">
                        <div className="flex flex-col items-center justify-center">
                            <p className="text-2xl font-bold text-navy-700 dark:text-white">{homesCount}</p>
                            <p className="text-sm font-normal text-gray-600">Homes</p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <p className="text-2xl font-bold text-navy-700 dark:text-white">
                                {roomsCount}
                            </p>
                            <p className="text-sm font-normal text-gray-600">Rooms</p>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <p className="text-2xl font-bold text-navy-700 dark:text-white">
                                {devicesCount}
                            </p>
                            <p className="text-sm font-normal text-gray-600">Devices</p>
                        </div>
                    </div>
                </div>
            }
        </Card>
    );
};

export default Banner;
